import React, { useState } from 'react';
import { AccountMenuContainer } from './styles';
import { useClickOutside } from 'customHook/useClickOutside';
import AccountNav from 'components/AccountNav';
import Avatar from 'assets/svg/Avatar.svg';

const AccountMenu = () => {
  const [open, setOpen] = useState(false);
  const { popUpRef, buttonRef } = useClickOutside(() => {
    setOpen(false)
  });

  return (
    <>
      <AccountMenuContainer
        ref={buttonRef}
        open={open}
        onClick={() => setOpen(!open)}
      >
        <img src={Avatar} alt={'avatar'} />
      </AccountMenuContainer>
      <AccountNav
        popUpRef={popUpRef}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};

export default AccountMenu;
